<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('vatCode.code') }}</label>
            <input
              v-model="model.vat_code"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('vat_code') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('vat_code')"
            >
              {{ errors.first('vat_code') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('vatCode.vatName')
            }}</label>
            <input
              v-model="model.vat_name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('vat_name') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('vat_name')"
            >
              {{ errors.first('vat_name') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('vatCode.vatRate')
            }}</label>
            <input
              v-model.number="model.vat_rate"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.has('vat_rate') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('vat_rate')"
            >
              {{ errors.first('vat_rate') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('vatCode.description') }}</label>
            <textarea
              v-model="model.description"
              class="form-control"
              rows="3"
              :class="{ 'is-invalid': errors.has('description') }"
            ></textarea>
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('description')"
            >
              {{ errors.first('description') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-1 ts-flex ts-space-x-6">
            <div>
              <label class="ts-text-xs ts-block">{{
                $t('vatCode.isInclusive')
              }}</label>
              <a-switch v-model="model.is_inclusive" />
            </div>
            <div>
              <label class="ts-text-xs ts-block">{{
                $t('vatCode.isActive')
              }}</label>
              <a-switch v-model="model.is_active" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'vatCodeForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      model: {
        vat_code: '',
        vat_name: '',
        vat_rate: null,
        description: '',
        is_inclusive: false,
        is_active: true
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('setting/vatCode', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('setting/vatCode/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('setting/vatCode/update', {
          id: this.model.vat_code_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.vat_code_id = this.edit_data.vat_code_id
        this.model.vat_code = this.edit_data.vat_code
        this.model.vat_name = this.edit_data.vat_name
        this.model.vat_rate = this.edit_data.vat_rate
        this.model.description = this.edit_data.description
        this.model.is_inclusive = this.edit_data.is_inclusive
        this.model.is_active = this.edit_data.is_active
      }
    }
  }
}
</script>
